import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice, isNil } from '@grandvisionhq/utils';
import { Mixed } from '../layout/Mixed.js';
import { Regular } from '../layout/Regular.js';
import { Subscription } from '../layout/Subscription.js';
import { containsOnlyContactLensesSubscriptionLineItems } from '../utils/contains-only-contact-lenses-subscription-line-items.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import { useCart } from '../../../context/Cart/context.js';

const TotalsContainer = ({ showSubTotal , hideSubscriptionExplainer , showTotalDiscount , className , isMiniCart  })=>{
    const settings = useCartSettings();
    const { cart  } = useCart();
    const { locale , currency , getLabel , getFormattedLabel  } = useIntl();
    const discountedPrice = (cart === null || cart === void 0 ? void 0 : cart.prices.discountPrice) ? cart.prices.subTotalPrice - cart.prices.discountPrice : (cart === null || cart === void 0 ? void 0 : cart.prices.subTotalPrice) || 0;
    const freeShippingRemainder = (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.freeAbove) ? cart.shippingMethod.freeAbove - discountedPrice : undefined;
    const formattedPrice = formatPrice({
        locale,
        value: freeShippingRemainder,
        currency,
        isCentAmount: true
    });
    const labels = React.useMemo(()=>({
            delivery: getLabel('cart.delivery'),
            freeDelivery: getLabel('cart.delivery.forFree'),
            subTotal: getLabel('cart.value.subTotal'),
            total: getLabel('cart.value.total'),
            todaysTotal: getLabel('cart.value.todaysTotal'),
            totalDiscount: getLabel('cart.value.totalDiscount'),
            paymentMethodPrice: getLabel('cart.value.paymentMethod'),
            subscriptionHeader: getLabel('cart.subscription.header'),
            freeShippingRemainder: getFormattedLabel('cart.delivery.freeShippingRemainder', {
                parseHTML: true,
                labelData: {
                    price: `<span className="price">${formattedPrice}</span>`
                }
            }),
            freeShippingReached: getLabel('cart.delivery.freeShippingReached')
        })
    , [
        getLabel,
        getFormattedLabel,
        formattedPrice
    ]);
    if (!cart) {
        return null;
    }
    const cartSettings = swcHelpers.objectSpread({}, settings, {
        showSubTotal: !isNil(showSubTotal) ? showSubTotal : settings.showSubTotal,
        showTotalDiscount: !isNil(showTotalDiscount) ? showTotalDiscount : settings.showTotalDiscount
    });
    if (cart.subscription && containsOnlyContactLensesSubscriptionLineItems(cart.lineItems)) {
        return /*#__PURE__*/ React.createElement(Subscription, {
            className: className,
            voucherCodes: cart.voucherCodes,
            subscription: cart.subscription,
            lineItems: cart.lineItems,
            hideSubscriptionExplainer: hideSubscriptionExplainer
        });
    }
    if (cart.subscription) {
        return /*#__PURE__*/ React.createElement(Mixed, {
            className: className,
            currency: currency,
            labels: labels,
            lineItems: cart.lineItems,
            prices: cart.prices,
            settings: cartSettings,
            hideSubscriptionExplainer: hideSubscriptionExplainer,
            subscription: cart.subscription,
            voucherCodes: cart.voucherCodes
        });
    }
    return /*#__PURE__*/ React.createElement(Regular, {
        className: className,
        currency: currency,
        labels: labels,
        prices: cart.prices,
        settings: cartSettings,
        voucherCodes: cart.voucherCodes,
        freeShippingThreshold: cart.shippingMethod.freeAbove,
        discountedPrice: discountedPrice,
        isMiniCart: isMiniCart
    });
};

export { TotalsContainer };
//# sourceMappingURL=TotalsContainer.js.map
